import PropTypes from "prop-types"
import React from "react"
import BaseWidgetGroup from "../base-widget-group"
import CommunityStorySpinner from "./community-story-spinner"
import CommunityStory from "./community-story"
import utils from "../../../lib/utils"
import { BlogPost } from "../../../models/BlogPost"

const NUM_TOTAL_BLOG_POSTS_IN_WIDGET = 6
const CLASS_NAME = 'home-page'
const WRAPPER_CLASS_NAME = 'community-stories-wrapper'
const BUTTON_CLASS_NAME = 'community-slider-button'

const AMOUNT_OF_POSTS = {
  small: 1,
  medium: 3,
  big: 3
}

class HomePageWidgetGroup extends React.Component<HomePageWidgetGroupProps> {
  constructor(props: HomePageWidgetGroupProps) {
    super(props)
    this.state = {}
    this.fetchBlogPosts = this.fetchBlogPosts.bind(this)
    this.getCard = this.getCard.bind(this)
    this.getSpinner = this.getSpinner.bind(this)
    this.getClassNameFromIndex = this.getClassNameFromIndex.bind(this)
  }

  async fetchBlogPosts() {
    // const ip = await utils.getIp()
    const ids = await this.props.fetchPrioritizedPostIds('', true)
    const posts = await this.props.fetchPostsByIds(
      ids.slice(0, NUM_TOTAL_BLOG_POSTS_IN_WIDGET)
    )
    return posts
  }

  getCard(post: BlogPost, index: number) {
    const size = this.getClassNameFromIndex(index)
    return (
      <CommunityStory
        key={post.id}
        post={post}
        className={CLASS_NAME}
        size = {size}
        shortTextLength={this.props.shortTextLength}
        currentLang={this.props.currentLang}
      />
    )
  }

  getClassNameFromIndex(index: number) {
    return (index%3===0 ) ? 'big' : 'small'
  }

  getSpinner(windowWidth: number) {
    return (
      <CommunityStorySpinner
        size={windowWidth}
      />
    )
  }

  render() {
    return (
      <BaseWidgetGroup
        amountOfPosts={AMOUNT_OF_POSTS}
        fetch={this.fetchBlogPosts}
        isSignedIn={this.props.isSignedIn}
        getCard={this.getCard}
        getSpinner={this.getSpinner}
        wrapperClassName={WRAPPER_CLASS_NAME}
        buttonClassName={BUTTON_CLASS_NAME}
      />
    )
  }
}


interface HomePageWidgetGroupProps {
  fetchPrioritizedPostIds: (ip: string, flag?: boolean) => Promise<number[]>,
  fetchPostsByIds: (ids: number[]) => Promise<BlogPost[]>,
  isSignedIn: () => boolean,
  shortTextLength: number,
  currentLang: string
}
declare namespace HomePageWidgetGroup { export var propTypes: any}
HomePageWidgetGroup.propTypes = {
    fetchPrioritizedPostIds: PropTypes.func.isRequired,
    fetchPostsByIds: PropTypes.func.isRequired,
    isSignedIn: PropTypes.func.isRequired,
    shortTextLength: PropTypes.number,
    currentLang: PropTypes.string
}

export default HomePageWidgetGroup
